import { MapedPoliciesDataType } from 'domain/shared/compliance';

const toVersionNumber = (version?: Nullable<string | number>) => Number(version || 0);

const getPreviousPolicyPath = (
  currentPath: string,
  policies: MapedPoliciesDataType[],
  currentComplianceName: string,
  currentMetadataVersion: number,
): Nullable<string> => {
  const currentPolicy = policies.find(item => item.policyPath === currentPath);
  const currentPolicyVersion = toVersionNumber(currentPolicy?.policyVersion);
  const targetVersion = currentPolicyVersion || currentMetadataVersion;
  const targetComplianceName = currentPolicy?.complianceName || currentComplianceName;

  const policyHistory = currentPolicy ? [currentPolicy, ...(currentPolicy.previousVersions ?? [])] : [];
  const candidatePolicies = [
    ...policyHistory,
    ...policies.filter(item => item.complianceName === targetComplianceName),
  ];
  const previousSignedPolicy = candidatePolicies.reduce<MapedPoliciesDataType | null>((bestMatch, item) => {
    const itemVersion = toVersionNumber(item.policyVersion);

    if (item.complianceName !== targetComplianceName || itemVersion >= targetVersion || !item?.isPolicyAccepted) {
      return bestMatch;
    }

    if (!bestMatch || itemVersion > toVersionNumber(bestMatch.policyVersion)) {
      return item;
    }

    return bestMatch;
  }, null);

  return previousSignedPolicy?.policyPath || null;
};

export default getPreviousPolicyPath;
